import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { Subscription, combineLatest, map } from 'rxjs';

import { T3AnalysisStore } from '../../../core/shared/t3-model/t3-analysis.store';

@Component({
    selector: 'app-t3-costmetrics',
    standalone: true,
    imports: [CommonModule, PopoverModule, ButtonModule],
    templateUrl: './t3-cost-metrics.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class T3CostmetricsComponent implements OnInit, OnDestroy {
    @Input() spanYears: 5 | 10 | 15 | 20 = 15;

    private store = inject(T3AnalysisStore);
    private cdr = inject(ChangeDetectorRef);
    private sub = new Subscription();

    readonly selectedSimulation$ = combineLatest([this.store.selectedRunId$, this.store.runsList$]).pipe(
        map(([id, runs]) => {
            const run = id ? runs.find((r) => r.id === id) : runs.length ? runs[runs.length - 1] : undefined;
            return run?.title ?? 'Basic Simulation';
        })
    );


    c4cInterventionCostDisplay = '—';
    healthcareSavingsDisplay = '—';
    netCostDisplay = '—';
    qalyDisplay = '—';
    netBenefitDisplay = '—';

    showNoSimInfo = true;

    ngOnInit(): void {
        this.sub.add(
            this.store.runsList$.subscribe((runs) => {
                const userSimulationCount = (runs || []).filter((run) => !this.isBaselineTitle(run.title)).length;
                this.showNoSimInfo = userSimulationCount === 0;
                this.cdr.markForCheck();
            })
        );
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }

    private isBaselineTitle(title: string | null | undefined): boolean {
        const normalized = String(title || '').trim().toLowerCase();
        return normalized === 'basic simulation' || normalized === 'baseline';
    }
}